
import { Dealer } from "@/types/dealer";
import { Coordinates } from "../types";
import { fetchDealersCore } from "./core";

/**
 * Public API for fetching recommended dealers data
 * 
 * @param selectedMetal The metal type (ORO/ARGENTO)
 * @param coordinates User coordinates for distance calculation
 * @param showLoadingNotification Whether to show a loading notification
 * @param forceRefresh Whether to bypass cache and force a fresh fetch
 * @param signal AbortSignal for request cancellation
 * @returns Promise with the dealers data
 */
export const fetchRecommendedDealersData = async (
  selectedMetal: string,
  coordinates?: Coordinates | null,
  showLoadingNotification: boolean = false,
  forceRefresh: boolean = false,
  signal?: AbortSignal,
  limitCount?: number
): Promise<Dealer[]> => {
  // Simply forward to the core implementation with appropriate parameters
  return fetchDealersCore(selectedMetal, coordinates, forceRefresh, signal, limitCount);
};
